/**
 * Roles are assignable and non-exclusive (BRD §4): one person can be both a
 * Manager and HR, so a user carries a set of roles rather than a single value.
 */
export const ROLES = ['EMPLOYEE', 'MANAGER', 'HR', 'ADMIN'];
export function isRole(value) {
    return typeof value === 'string' && ROLES.includes(value);
}
/**
 * Every capability the server enforces. The client may use these to hide UI,
 * but the server checks them again on every request (BRD §6, Security).
 */
export const PERMISSIONS = [
    // Self-service
    'leave:submit',
    'report:read:self',
    // Manager scope (direct reports only)
    'team:read',
    'leave:approve:team',
    'announcement:send:team',
    'report:read:team',
    // HR scope (org-wide)
    'org:read',
    'leave:approve:any',
    'leave:balance:adjust',
    'leave:policy:manage',
    'announcement:send:org',
    'report:read:org',
    'report:export',
    // Admin
    'user:manage',
    'map:manage',
    'integration:manage',
    'audit:read',
];
const EMPLOYEE_PERMISSIONS = ['leave:submit', 'report:read:self'];
const MANAGER_PERMISSIONS = [
    ...EMPLOYEE_PERMISSIONS,
    'team:read',
    'leave:approve:team',
    'announcement:send:team',
    'report:read:team',
];
const HR_PERMISSIONS = [
    ...EMPLOYEE_PERMISSIONS,
    'team:read',
    'org:read',
    'leave:approve:any',
    'leave:approve:team',
    'leave:balance:adjust',
    'leave:policy:manage',
    'announcement:send:org',
    'announcement:send:team',
    'report:read:team',
    'report:read:org',
    'report:export',
];
const ADMIN_PERMISSIONS = [
    ...EMPLOYEE_PERMISSIONS,
    'team:read',
    'org:read',
    'user:manage',
    'map:manage',
    'integration:manage',
    'audit:read',
    'announcement:send:org',
    'announcement:send:team',
    'report:read:org',
    'report:read:team',
    'report:export',
];
export const ROLE_PERMISSIONS = {
    EMPLOYEE: EMPLOYEE_PERMISSIONS,
    MANAGER: MANAGER_PERMISSIONS,
    HR: HR_PERMISSIONS,
    ADMIN: ADMIN_PERMISSIONS,
};
export function permissionsFor(roles) {
    const set = new Set();
    for (const role of roles) {
        for (const permission of ROLE_PERMISSIONS[role] ?? [])
            set.add(permission);
    }
    return [...set];
}
export function can(roles, permission) {
    return roles.some((role) => (ROLE_PERMISSIONS[role] ?? []).includes(permission));
}
//# sourceMappingURL=roles.js.map